import SystemConfigurationService from './service';

export * from './reqres';

export default SystemConfigurationService;
